// src/com/auto_using_car_info/AutoUsingCarInfoDict.js
import { InputType, TableColumnType } from "../../value/AppConst";

const Dict = {
    // toAdd, toEdit : mark if need to submit for mutation
    dcCd : {
		id: 'dcCd', label: '물류센터',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // varchar(3) 서버에서 받은 값을 사용하여 올림.
    planDate : {
		id: 'planDate', label: '배차일자',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // date 서버에서 받은 값을 사용하여 올림.
    vehTypeId : {
		id: 'vehTypeId', label: '차종코드',
		type: InputType.text, required: true, toAdd: true, toEdit: true,
	}, // varchar(10) 서버에서 받은 값을 사용하여 올림.
    usingCarCnt : {
		id: 'usingCarCnt', // label: '가용차량 수', -- 넣지 마시오!!
		type: InputType.number, required: true, toAdd: true, toEdit: true,
		check: (value) => {return value >= 0 && value <= 300},
	}, // int(11)
    rentYn : { id: 'rentYn', label: '용차여부', }, // enum('N','Y')
    vehTypeName : { id: 'vehTypeName', label: '차종', }, // varchar(50)
    dcName : { id: 'dcName', label: '물류센터', }, // varchar(20)
};

/**
 * AUTO_USING_CAR_INFO React Component Dictionary for Input and Output
 * Project: NewTOP for cloud
 * 2024-10-24 10:51:54 using DbdbTap
 */
export const AutoUsingCarInfoDictionary = {
    inputMap: Dict,
    errorTitle: {
        Upload: '차종별 가용차량 수 일괄 설정 오류',
        Edit: '차종별 가용차량 수 수정 오류',
        Remove: '차종별 가용차량 수 삭제 오류',
        Get: '차종별 가용차량 수 조회 오류',
    },
    tableProps: {
        tableId: 'autoUsingCarInfoTable',
        uniqueKey: 'vehTypeId',
        flexOption: {
            multiChecker:false,
            hideFirstTopButton: false,
            hideColumnConfig: true,
            hideBubble: false,
            growToFill: true,
        },
        columns: [
            //print using getTableColumnOption(c,t,i)
            //{ id: 'dcCd', label: Dict.dcCd.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'dcName', label: Dict.dcName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'planDate', label: Dict.planDate.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehTypeId', label: Dict.vehTypeId.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 120, show: true, option:{align: 'center', type:TableColumnType.TEXT} },
            //{ id: 'vehTypeAlias', label: '차종별칭', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            //{ id: 'rentYn', label: Dict.rentYn.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'usingCarCnt', label: '가용차량 수', width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
            { id: 'regDate', label: "등록일", width: 120, show: true, option:{align: 'center', print:(r,i,v)=>v?v.substring(0,16):'-'} },
            //{ id: 'regUser', label: "regUser", width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
            { id: 'regUserName', label: "등록자", width: 80, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        ]
    },
    inputTableColumns : [
        { id: 'vehTypeName', label: Dict.vehTypeName.label, width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        { id: 'vehTypeAlias', label: '차종별칭', width: 120, show: true, option:{align: 'inherit', type:TableColumnType.TEXT} },
        { id: 'usingCarCnt', label: Dict.usingCarCnt.label, width: 120, show: true, option:{align: 'right', type:TableColumnType.INTEGER} },
    ]
};
